export default "__VITE_ASSET__M53JvDKZ__"